import styled, { css } from "styled-components";
import {hexToRgba} from "../../../themes/hex-to-rgba";

interface OverlayComponentDefaultBoxProps {
    show?: boolean;
    zIndex?: number;
}

export const OverlayComponentDefaultBox = styled.div<OverlayComponentDefaultBoxProps>`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100vh;
    background-color: ${props => hexToRgba(props.theme.colors.background, 0.85)};
    z-index: -1;
    opacity: 0;
    transition: all 0.5s ease-in;

    ${({show, zIndex}) => show ? css`
        opacity: 0.85;
        z-index: ${zIndex ? zIndex : 102};
    ` : null}
`;
